import { z } from "zod";
import {
    paymentSettlementZodObject,
    type PaymentSettlement,
} from "./payment.settlement";
import {
    refundSettlementZodObject,
    type RefundSettlement,
} from "./refund.settlement";

type Settlement = PaymentSettlement | RefundSettlement;

type SettlementType = Settlement["type"];

const settlementZodSchema: z.ZodSchema<Settlement> = z.discriminatedUnion(
    "type",
    [paymentSettlementZodObject, refundSettlementZodObject],
);

export { settlementZodSchema };
export type { Settlement, SettlementType };
